var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 329.27,
    height: 329.263,
    viewBox: "0 0 329.27 329.263",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "_001-close",
    "data-name": "001-close",
    d: "M194.8,164.77,323.012,36.555A21.329,21.329,0,0,0,292.848,6.391L164.633,134.606,36.422,6.391A21.329,21.329,0,0,0,6.258,36.555L134.469,164.77,6.258,292.985a21.329,21.329,0,1,0,30.164,30.164L164.633,194.934,292.848,323.149a21.329,21.329,0,0,0,30.164-30.164Zm0,0",
    transform: "translate(0 -0.136)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuClose);
export default __webpack_public_path__ + "static/media/menuClose.67570dcafe7b33d80656bd33bfe5b526.svg";
export { ForwardRef as ReactComponent };